import type { BestSellingProduct } from "@circle-react/apps/EoyRecapApp/types";
import { abbreviateNumber } from "@/react/helpers/number";
interface BestSellingProductCardProps {
  product: BestSellingProduct;
}

export const BestSellingProductCard = ({
  product,
}: BestSellingProductCardProps) => {
  if (!product) return null;

  return (
    <div className="relative w-full max-w-md">
      <div className="absolute inset-0 bg-[rgba(255,255,255,0.14)] rounded-2xl translate-y-8 scale-[0.9]" />
      <div className="absolute inset-0 bg-[rgba(255,255,255,0.08)] rounded-2xl translate-y-16 scale-[0.80]" />

      <div className="relative bg-[#645B69] rounded-2xl p-3 shadow-2xl z-10 flex flex-col gap-4">
        <div className="bg-[rgba(255,255,255,0.24)] h-40 w-full rounded-2xl" />
        <div className="flex flex-col gap-2">
          <h3 className="text-white text-base font-semibold leading-tight text-balance line-clamp-3">
            {product.Paywall}
          </h3>
          <p className="flex items-center justify-between w-full">
            <p className="text-white text-sm font-medium leading-none tracking-[-0.25px]">
              ${abbreviateNumber(product.Amount)}
            </p>
            <p className="text-white text-sm font-medium leading-none tracking-[-0.25px]">
              #{abbreviateNumber(product.Count)}
            </p>
          </p>
          <div className="bg-[rgba(255,255,255,0.24)] h-4 w-1/3 rounded-full" />
        </div>
      </div>
    </div>
  );
};
